'use strict';

const heroVideo = ( $ ) => {
	const video = document.getElementById( 'home-hero-video' );
	const $title = $( '#home-hero .page-title' );

	return {
		init() {
			if ( ! video ) {
				return;
			}

			video.muted = true;
			video.play();

			setInterval( function() {
				const currentTime = video.currentTime;

				if ( currentTime > 0 && currentTime < 14 ) {
					$title.addClass( 'invert' );
				} else {
					$title.removeClass( 'invert' );
				}
			}, 500 );
		}
	};
}

heroVideo( jQuery ).init();

const menuToggle = $ => {
	const $toggle = $( '#menu-toggle' );
	const $navbarLinks = $( '#navbar-social, #nav-menu' );
	const $menu = $( '#site-menu' );
	const state = {
		opened: 'menu-open',
		closed: 'menu-closed',
		opening: 'menu-opening',
		closing: 'menu-closing',
	};

	const toggleMenu = () => {
		if ( $( 'body' ).hasClass( state.closed ) ) {
			showMenu();
		}

		if ( $( 'body' ).hasClass( state.opened ) ) {
			hideMenu();
		}
	};

	const showMenu = () => {
		const scrollbarWidth = ( window.innerWidth - document.body.clientWidth ) + 'px';
		hideNavbarLinks();

		$( 'body' ).css( { paddingRight: scrollbarWidth } )
			.removeClass( state.closed )
			.addClass( state.opening );

		$menu
			.css( {
				display: 'block',
				opacity: 0
			} )
			.animate( {
				opacity: 1,
			}, 300, function() {
				bindTabFocus();

				$( 'body' )
					.removeClass( state.opening )
					.addClass( state.opened );
			} );
	};

	const hideMenu = () => {
		showNavbarLinks();

		$( 'body' ).css( { paddingRight: 0 } )
			.removeClass( state.opened )
			.addClass( state.closing );

		unBindTabFocus();

		$menu
			.css( {
				display: 'block',
				opacity: 1
			} )
			.animate( {
				opacity: 0,
			}, 300, function() {
				$( this ).removeAttr( 'style' );

				$( 'body' )
					.removeClass( state.closing )
					.addClass( state.closed );
			} );
	};

	const hideNavbarLinks = () => {
		$navbarLinks.animate( {
			opacity: 0,
		}, 300, function() {
			$( this )
				.removeAttr( 'style' )
				.css( { display: 'none' } );
		} );
	};

	const showNavbarLinks = () => {
		$navbarLinks
			.removeAttr( 'style' )
			.css( { opacity: 0 } )
			.animate( {
				opacity: 1,
			}, 300, function() {
				$( this ).removeAttr( 'style' );
			} );
	};

	const bindTabFocus = () => {
		// Set focus from toggle btn to first link
		const $firstLink = $( '#site-menu a:first' );
		$toggle.on( 'keydown', e => {
			if ( ( e.keyCode === 9 && ! e.shiftKey ) ) {
				e.preventDefault();
				$firstLink.get( 0 ).focus();
			}
		} );

		// Set focus from first link to toggle btn
		$firstLink.on( 'keydown', e => {
			if ( ( e.keyCode === 9 && e.shiftKey ) ) {
				e.preventDefault();
				$toggle.get( 0 ).focus();
			}
		} );

		// Set focus from last link to toggle btn
		const $lastLink = $( '#site-menu a:last' );
		$lastLink.on( 'keydown', e => {
			if ( ( e.keyCode === 9 && ! e.shiftKey ) ) {
				e.preventDefault();
				$toggle.get( 0 ).focus();
			}
		} );

		// Set focus from toggle btn to last link
		$toggle.on( 'keydown', e => {
			if ( ( e.keyCode === 9 && e.shiftKey ) ) {
				e.preventDefault();
				$lastLink.get( 0 ).focus();
			}
		} );
	};

	const unBindTabFocus = () => {
		const $firstLink = $( '#site-menu a:first' );
		const $lastLink = $( '#site-menu a:last' );

		$toggle.off( 'keydown' );
		$firstLink.off( 'keydown' );
		$lastLink.off( 'keydown' );
	}

	return {
		init() {
			if ( ! $toggle.length ) {
				return;
			}

			this.bind();
		},
		bind() {
			$toggle.on( 'click', () => {
				toggleMenu();
			} );

			// Add esc event listeners
			$( document ).on( 'keydown', ( e ) => {
				if ( e.keyCode === 27 && $( 'body' ).hasClass( state.opened ) ) {
					toggleMenu();
				}
			} );
		},
	};
};

menuToggle( jQuery ).init();

const accordionToggle = ( $ ) => {
	let $currentPanel = null;
	let siblings = [];

	const toggle = $panel => {
		$currentPanel = $panel;
		getSiblingAccordions( $panel );

		if ( isCurrentlyAnimating() ) {
			return;
		}

		// closeSiblings();

		if ( $panel.attr( 'data-state' ) === 'closed' ) {
			openPanel( $panel );
		} else {
			closePanel( $panel );
		}
	};

	const openPanel = $panel => {
		const $content = $panel.find( '[data-accordion="content"]' );
		const newHeight = $content.get( 0 ).scrollHeight;

		$panel.attr( 'data-state', 'expanding' );

		$content.animate( {
			height: newHeight
		}, 400, () => {
			$panel.attr( 'data-state', 'expanded' );
			$content.css( { height: 'auto' } );
		} );
	};

	const closePanel = $panel => {
		const $content = $panel.find( '[data-accordion="content"]' );

		$panel.attr( 'data-state', 'closing' );

		$content.animate( {
			height: 0
		}, 400, () => {
			$panel.attr( 'data-state', 'closed' );
		} );
	};

	const isCurrentlyAnimating = () => {
		const state = $currentPanel.attr( 'data-state' );

		if ( state === 'expanding' || state === 'closing' ) {
			return true;
		}

		for ( let i = 0; i < siblings.length; i++ ) {
			const $panel = siblings[ i ];
			const siblingState = $panel.attr( 'data-state' );

			if ( siblingState === 'expanding' || siblingState === 'closing' ) {
				return true;
			}
		}
	};

	const closeSiblings = () => {
		for ( let i = 0; i < siblings.length; i++ ) {
			const $panel = siblings[ i ];

			if ( $panel.attr( 'data-state' ) === 'expanded' ) {
				closePanel( $panel );
			}
		}
	};

	const getSiblingAccordions = $accordion => {
		siblings = [];
		let searchPrev = true;
		let searchNext = true;
		let $currentEl = null;

		while ( searchPrev === true || searchNext === true ) {
			$currentEl = $currentEl === null ? $accordion : $currentEl;

			if ( searchPrev === true && $currentEl.prev( '[data-accordion="panel"]' ).length ) {
				siblings.push( $currentEl.prev( '[data-accordion="panel"]' ) );
				$currentEl = $currentEl.prev( '[data-accordion="panel"]' );
				continue;
			} else if ( searchPrev === true && ! $currentEl.prev( '[data-accordion="panel"]' ).length ) {
				searchPrev = false;
				$currentEl = null;
				continue;
			}

			if ( searchNext === true && $currentEl.next( '[data-accordion="panel"]' ).length ) {
				siblings.push( $currentEl.next( '[data-accordion="panel"]' ) );
				$currentEl = $currentEl.next( '[data-accordion="panel"]' );
				continue;
			} else if ( searchNext === true && ! $currentEl.next( '[data-accordion="panel"]' ).length ) {
				searchNext = false;
			}
		}

		return siblings;
	};

	return {
		init() {
			if ( ! $( '[data-accordion="panel"]' ).length ) {
				return;
			}

			this.bind();
		},
		bind() {
			$( '[data-accordion="toggle"]' ).on( 'click', e => {
				toggle( $( e.currentTarget ).parents( '[data-accordion="panel"]' ) );
			} );
		}
	};
};

accordionToggle( jQuery ).init();

const schoolDirectoryFilters = $ => {
	const $form = $( '#school-directory-filters' );

	const changeView = view => {
		$( '#view-wrapper' )
			.removeClass( 'show-grid show-list' )
			.addClass( `show-${ view }` );
	};

	return {
		init() {
			if ( ! $form.length ) {
				return;
			}

			this.bind();
		},
		bind() {
			$( 'input[name="view-toggle"]' ).on( 'change', () => {
				changeView( $( 'input[name="view-toggle"]:checked' ).val() );
			} );
		},
	};
};

schoolDirectoryFilters( jQuery ).init();

const quoteCarousel = $ => {
	const $carousel = $( '#quote-carousel .carousel-wrapper' );

	const options = {
		slidesToShow: 1,
		fade: true,
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,
		arrows: false,
	};

	const initCarousel = () => {
		$carousel.slick( options );
	};

	return {
		init() {
			if ( ! $carousel.length ) {
				return;
			}

			this.bind();
		},
		bind() {
			initCarousel();
		}
	};
};

quoteCarousel( jQuery ).init();

const paginationSelect = $ => {
	const $select = $( '[data-pagination="select"]' );

	return {
		init() {
			if ( ! $select.length ) {
				return;
			}

			this.bind();
		},
		bind() {
			$select.on( 'change', e => {
				window.location.href = e.target.value;
			} );
		}
	};
};

paginationSelect( jQuery ).init();

const scrollTo = $ => {
	const $scrollLinks = $( 'a[href^="#"]' );

	return {
		init() {
			if ( ! $scrollLinks.length ) {
				return;
			}

			this.bind();
		},
		bind() {
			$scrollLinks.on( 'click', e => {
				const $link = $( e.currentTarget );
				const $target = $( $link.attr( 'href' ) );

				if ( ! $target.length ) {
					return;
				}

				e.preventDefault();

				$( 'html, body' ).animate( {
					scrollTop: $target.offset().top
				}, 400 );
			} );
		}
	};
};

scrollTo( jQuery ).init();

( function( $ ) {
	"use strict";

	function setCookie(name,value,days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}
	function getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}
	function eraseCookie(name) {
		document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}

	$( '.select-filter' ).on( 'change', function() {
		//$('#' + formId + ' select:not(#' + $(this).attr('id') + ')').val("");
		this.form.submit();
	} );

	var myModal = new bootstrap.Modal(document.getElementById('schoolSignup'))

	var schoolSignupShown = getCookie('schoolSignupShown')
	var hash = window.location.hash;

	if (!schoolSignupShown) {
		myModal.show();
		setCookie('schoolSignupShown', true, 7)
	} else if (hash === '#schoolSignup') {
		myModal.show();
	}




} )( jQuery );